import { Skeleton } from "../Skeleton";

export const LayoutSkeleton = () => {
  return (
    <div className="flex h-dvh w-full">
      {/* Sidebar Skeleton */}
      <div className="bg-secondary-solid relative hidden w-64 flex-col border-r lg:flex lg:w-[271px]">
        {/* Sidebar Header - Logo */}
        <div className="border-b p-5">
          <Skeleton className="h-[39px] w-40 lg:w-[180px]" />
        </div>

        {/* Sidebar Menu Items */}
        <div className="flex-1 space-y-2 p-5">
          {/* eslint-disable react/no-array-index-key */}
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={`sidebar-menu-${index}`}
              className="flex items-center gap-3"
            >
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-4 w-32" />
            </div>
          ))}
          {/* eslint-enable react/no-array-index-key */}
        </div>

        {/* Sidebar Footer - AI Section */}
        <div className="p-5">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-4 w-24" />
            </div>
            <Skeleton className="h-3 w-40" />
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <main className="flex-1">
        {/* Header Skeleton */}
        <header className="sticky top-0 z-50 flex min-h-20 w-full items-center border-b bg-background">
          <div className="flex w-full items-center justify-between gap-4 px-4 sm:pl-5 sm:pr-8">
            {/* Location */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-4 w-24" />
            </div>

            {/* Search Input */}
            <Skeleton className="hidden h-[38px] w-full max-w-[500px] md:block" />

            {/* Right Group */}
            <div className="flex items-center gap-6">
              <Skeleton className="h-9 w-20 rounded" />
              <Skeleton className="h-9 w-9 rounded-full" />
              <div className="flex items-center gap-3">
                <div className="flex flex-col items-end gap-1">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-3 w-16" />
                </div>
                <Skeleton className="h-9 w-9 rounded-full" />
              </div>
            </div>
          </div>
        </header>

        {/* Content Area Skeleton */}
        <div className="min-h-[calc(100vh-80px)] w-full p-4 sm:p-5 lg:p-6">
          <div className="space-y-4">
            {/* Page Title */}
            <div className="space-y-2">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-32" />
            </div>

            {/* Content Cards/Table */}
            <div className="space-y-3">
              {/* eslint-disable react/no-array-index-key */}
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton
                  key={`layout-content-skeleton-${index}`}
                  className="h-16 w-full"
                />
              ))}
              {/* eslint-enable react/no-array-index-key */}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
